import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import cloneDeep from 'lodash/cloneDeep';
import { Store } from '@ngrx/store';
import { startWith, Subject, Subscription } from 'rxjs';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-edit-supplier-product',
  templateUrl: './edit-supplier-product.component.html',
  styleUrls: ['./edit-supplier-product.component.css']
})
export class EditSupplierProductComponent implements OnInit {

  @Input() productData: any;
  @Input() selectedSupplierId: number;
  @Input() productModalMode: string;
  @Output() onClose = new EventEmitter<void>();
  @Output() onSave = new EventEmitter<any>();
  @Output() productUpdated = new EventEmitter<any>();

  constructor(private store: Store<{ languageData: [] }>,
    private http: HttpClient, private domSanitizer: DomSanitizer, private sanitizer: DomSanitizer) { }

  // 🔽 Language support
  public lang: any = {};
  languageData$: any;
  selectedLanguage: string = '';
  // 🌐 Handle Language Tokens
  public getLanguageTokens(): void {
    this.languageData$ = this.store.select(state => state.languageData).pipe(
      startWith([]),
    );

    this.languageData$.subscribe((data) => {
      if (
        !data ||
        !data.languageData ||
        Object.keys(data.languageData).length <= 0
      ) {
        console.log('No data to process', new Date().toISOString());
        return;
      }

      setTimeout(() => {
        this.lang = {};
        this.selectedLanguage = sessionStorage.getItem('language') ?? 'en';

        for (let token of data.languageData) {
          this.lang[token.key] = token[this.selectedLanguage];
        }
      }, 0);
    });
  }

  // input number field
  allowOnlyNumbers(event: KeyboardEvent): void {
    const allowedKeys = [
      'Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'
    ];

    if (allowedKeys.includes(event.key)) {
      return;
    }

    const isDigit = /^[0-9]$/.test(event.key);
    if (!isDigit) {
      event.preventDefault(); // Block anything that's not a digit
    }
  }

  // ********************************** Handling Update Product **************************************
  product: any;
  // *************************** My First Row *************************************
  countries = [
    { id: 2, name: 'Canada' },
    { id: 1, name: 'USA' }];

  countryDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'name',
    allowSearchFilter: false,
    closeDropDownOnSelection: true
  };

   productIdentifier = [
    { id: 1, name: 'Mental Health & Wellbeing' },
    { id: 2, name: 'Health & Dental' },
    { id: 3, name: 'Life & Disability Protection' },
    { id: 4, name: 'Private Health' },
    { id: 5, name: 'Other' }
  ];
  showOtherInput: boolean = false;
  onSelectProductIdentityFier(item: any): void {
    console.log("onSelectProductIdentityFier :", item);
    this.showOtherInput = item.name === 'Other';
    if (!this.showOtherInput) {
      this.product.productInfo.productNewInputIdentifier = '';
    }
  }

  onDeselectProductIdentityFier(item: any): void {
    if (item.name === 'Other') {
      this.showOtherInput = false;
      this.product.productInfo.productNewInputIdentifier = '';
    }
  }

  provinces = [
    { id: 1, name: 'Alberta', shortName: 'AB' },
    { id: 2, name: 'British Columbia', shortName: 'BC' },
    { id: 3, name: 'Manitoba', shortName: 'MB' },
    { id: 4, name: 'New Brunswick', shortName: 'NB' },
    { id: 5, name: 'Newfoundland and Labrador', shortName: 'NL' },
    { id: 6, name: 'Nova Scotia', shortName: 'NS' },
    { id: 7, name: 'Ontario', shortName: 'ON' },
    { id: 8, name: 'Prince Edward Island', shortName: 'PE' },
    { id: 9, name: 'Quebec', shortName: 'QC' },
    { id: 10, name: 'Saskatchewan', shortName: 'SK' },
    { id: 11, name: 'Northwest Territories', shortName: 'NT' },
    { id: 12, name: 'Nunavut', shortName: 'NU' },
    { id: 13, name: 'Yukon', shortName: 'YT' }
  ];

  // ****************************** Third Row ****************************************
  pdfBase64Data: string | null = null;
  tileSafeUrl: SafeResourceUrl | null = null;
  showTileExcelPopup: boolean = false
  html = '';
  // product resource
  showProduct_Resource_QuillEditor: boolean = false;
  savedProductResourceContent = '';
  previewProduct_Resource_QuillEditor: boolean = false;
  editorContentForProductResource: string = '';
  safeHtml: SafeHtml;

  // Tile description
  showTileQuillEditor: boolean = false;
  previewQuillEditor: boolean = false;
  savedContent = '';
  tilePreviewType: 'text' | 'excel' | 'pdf' | 'doc' | 'unsupported' | null = null;

  // something
  showEditor = false;

  //Handing booklet pdf
  bookletUrl: SafeResourceUrl | null = null;
  bookletFileName: string = "";
  tileTextContent: string | null = null;

  handleBookletFile(event: any): void {
    const file = event.target.files[0];
    if (!file) return;

    this.product.productDetails.bookletFileName = file.name;
    const ext = file.name.split('.').pop()?.toLowerCase();
    const reader = new FileReader();

    if (['txt', 'csv', 'json', 'xml', 'html', 'doc', 'docx'].includes(ext!)) {
      reader.onload = () => {
        this.product.productDetails.bookletFile = (reader.result as string).split(',')[1];
        this.tilePreviewType = 'text';
        this.tileTextContent = reader.result as string;
      };
      reader.readAsText(file);
    } else if (ext === 'pdf') {
      reader.onload = () => {
        this.tilePreviewType = 'pdf';
        this.bookletUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(reader.result as string);
        this.product.productDetails.bookletFile = (reader.result as string).split(',')[1];
        console.log("this.bookletUrl  :", this.bookletUrl);
      };
      reader.readAsDataURL(file);
    } else {
      this.tilePreviewType = 'unsupported';
    }
  }

  setBookletFileUrl(base64: string): void {
    console.log("can i see base64 :", base64)
    this.bookletUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`data:application/pdf;base64,${base64}`);
    console.log("can i see pdf :", this.bookletUrl)
  }

  // product resource
  onViewProduct_Resource_Description() {
    this.product.productDetails.productResourceHTML = this.sanitizer.bypassSecurityTrustHtml(this.product.productDetails.productResourceContent);
    this.previewProduct_Resource_QuillEditor = true;
  }
  onCanceloOfProductResourceDescription(): void {
    this.showProduct_Resource_QuillEditor = false
    // this.product.productDetails.productResourceContent = null;
  }
  quillModulesForProductResource = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['blockquote', 'code-block'],
      [{ header: 1 }, { header: 2 }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ script: 'sub' }, { script: 'super' }],
      [{ size: ['small', false, 'large', 'huge'] }],
      [{ header: [false, 1, 2, 3, 4, 5, 6] }],
      [{ color: [] }, { background: [] }],
      [{ font: [] }],
      [{ align: [] }],
      ['clean'],
      ['link']
    ]
  };

  onProductResourceFileSave(): void {
    // Step 1: Store the editor content for preview
    this.savedProductResourceContent = this.product.productDetails.productResourceContent;
    this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(this.html);
    this.product.productDetails.productResourceHTML = this.sanitizer.bypassSecurityTrustHtml(this.product.productDetails.productResourceContent);

    this.showProduct_Resource_QuillEditor = false;
    // this.this.product.productDetails.tileDescriptionContent = null;
  }
  onProductPreviewClosePopup() {
    this.previewProduct_Resource_QuillEditor = false;
  }

  //Tile decription
  onViewTileDescription() {
    this.product.productDetails.tileDescriptionHTML = this.sanitizer.bypassSecurityTrustHtml(this.product.productDetails.tileDescriptionContent);
    this.previewQuillEditor = true;
  }
  onCanceloOfTileDescription(): void {
    this.showTileQuillEditor = false
    // this.product.productDetails.tileDescriptionContent = null;
  }
  quillModules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['blockquote', 'code-block'],
      [{ header: 1 }, { header: 2 }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ script: 'sub' }, { script: 'super' }],
      [{ size: ['small', false, 'large', 'huge'] }],
      [{ header: [false, 1, 2, 3, 4, 5, 6] }],
      [{ color: [] }, { background: [] }],
      [{ font: [] }],
      [{ align: [] }],
      ['clean'],
      ['link']
    ]
  };
  onTileFileSave(): void {
    // Step 1: Store the editor content for preview
    this.savedContent = this.product.productDetails.tileDescriptionContent;
    this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(this.html);
    this.product.productDetails.tileDescriptionHTML = this.sanitizer.bypassSecurityTrustHtml(this.product.productDetails.tileDescriptionContent);
    this.showTileQuillEditor = false;
    // this.this.product.productDetails.tileDescriptionContent = null;
  }
  onClosePopup() {
    this.previewQuillEditor = false;
  }
  // close popup
  resetTilePreview(): void {
    this.showTileExcelPopup = false;
  }

  // ******************************* Vendor And Invoicing Section ********************************
  onBillingTypeChange() {
    this.product.productDetails.paymentOption = "PAD From GB";
  }

  // ******************************** Pricing *********************************************
  baseUnitValues = [
    { id: 1, value: '$1' },
    { id: 2, value: '$100' },
    { id: 3, value: '$1000' },
    { id: 4, value: '$10000' },
    { id: 5, value: '$100000' },
    { id: 6, value: '$1000000' }
  ];

  // ************************************* Five Table **************************************

  filteredProvinces: any[] = [];

  // product: any = {};
  showProductModal: boolean = false;

  dropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'shortName',
    itemsShowLimit: 2,
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    enableCheckAll: true,
    allowSearchFilter: true
  };

  //my first row functions code
  onItemSelect(item: any) {
    this.updateFilteredProvinces();
    console.log('Selected:', item);
  }

  onSelectAll(items: any) {
    console.log('All Selected:', items);
    this.updateFilteredProvinces();
    this.filteredProvinces = [...items];
  }


  onDeSelectAll(items: any) {
    this.filteredProvinces = [];
  }

  onItemDeSelect(item: any) {
    this.updateFilteredProvinces();
  }

  //here we are filtering provinces to show in pricing area section dropdown
  updateFilteredProvinces() {
    this.filteredProvinces = this.product.areas.areasData.selectedProvinces;
  }

  //increase table rows 
  generatePricingAreaRows(count: number) {
    this.product.areas.areasData = [];
    for (let i = 0; i < count; i++) {
      this.product.areas.areasData.push({
        area: i + 1,
        name: '',
        selectedProvinces: []
      });
    }
  }

  // increase tier table row
  generateTieredRows(count: number) {
    this.product.tiers.tiersData = Array.from({ length: count }, () => ({ name: '' }));
    if (this.product.tiers.noOfTiers <= 0) {
      this.product.tiers.isTierEnabled = false;
      this.product.tiers.noOfTiers = null;
    } else {
      this.product.tiers.isTierEnabled = true;
    }
  }
  // Filtered list per row
  getAvailableProvinces(index: number) {
    const selectedInOthers = this.product.areas.areasData
      .filter((_, i) => i !== index)
      .flatMap(r => r.selectedProvinces.map(p => p.id));

    return this.filteredProvinces.filter(
      p => !selectedInOthers.includes(p.id)
    );
  }
  //pricing provinces setting
  pricingProvincesdropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'shortName',
    itemsShowLimit: 1,
    allowSearchFilter: true,
    enableCheckAll: true,
    closeDropDownOnSelection: false
  };
  // ************************************ End All Fields ***********************************

  generateVariants(count: number) {
    this.product.variants.variantsData = [];
    for (let i = 0; i < count; i++) {
      this.product.variants.variantsData.push({
        name: '',
      });
    }
  }
  generateAgeBands(count: number) {
    this.product.ageBands.ageBandsData = [];
    for (let i = 0; i < count; i++) {
      this.product.ageBands.ageBandsData.push({
        start: null,
        end: null,
      });
    }
    this.product.ageBands.noOfAgeBands = count;
  }
  generateCategoryRows(count: number) {
    this.product.serviceLevel.servicesData = [];
    for (let i = 0; i < count; i++) {
      this.product.serviceLevel.servicesData.push({
        name: '',
      });
    }
    // this.product.serviceLevel.servicesData = Array.from({ length: count }, () => ({ name: '' }));
    // if (this.product.serviceLevel.noOfServiceLevel <= 0) {
    //   this.product.serviceLevel.isServiceLevelEnabled = false;
    //   this.product.serviceLevel.noOfServiceLevel = null;
    // } else {
    //   this.product.serviceLevel.isServiceLevelEnabled = true;
    // }
  }
  // This updates next row's start when current row's end changes
  onEndChange(index: number): void {
    const currentEnd = this.product.ageBands.ageBandsData[index].end;
    if (index + 1 < this.product.ageBands.ageBandsData.length) {
      this.product.ageBands.ageBandsData[index + 1].start = currentEnd;
    }
  }
  onAgeBandChange(value: boolean): void {
    this.product.ageBands.isAgeBandEnabled = value;
    if (value) {
      this.product.tiers.isTierEnabled = false;
      this.product.tiers.noOfTiers = null
      this.product.tiers.tiersData = [];
    } else {
      this.product.ageBands.ageBandsData = [];
      this.product.ageBands.noOfAgeBands = null;
    }
  }
  onTierChange(value: boolean): void {
    this.product.tiers.isTierEnabled = value;

    if (value) {
      this.product.ageBands.isAgeBandEnabled = false;
      this.product.ageBands.noOfAgeBands = null;
      this.product.ageBands.ageBandsData = [];
    } else {
      this.product.tiers.tiersData = [];
      this.product.tiers.noOfTiers = null;
    }
  }
  onVarientChange(value: boolean): void {
    this.product.variants.isVariantEnabled = value;
    this.product.variants.noOfVariants = null;
    this.product.variants.variantsData = [];
  }
  onServiceLevelChange(value: boolean): void {
    this.product.serviceLevel.isServiceLevelEnabled = value;
    this.product.serviceLevel.noOfServiceLevel = null;
    this.product.serviceLevel.servicesData = [];
  }

  // ************************************** Signup Form ***************************************
  rows = [
    {
      fields: [
        { fieldName: '', value: '', rule: '' },
        { fieldName: '', value: '', rule: '' },
        { fieldName: '', value: '', rule: '' }
      ]
    }
  ];


  isSavedOnce = false;
  buttonLabel = 'Save';

  onFieldChange(): void {
    if(!this.isAllFieldsFilled()){
      this.product.provisioningAndReporting.isSelfBillingEnabled= false;
    }
  }

  //validation of next section
  isAllFieldsFilled(): boolean {
    return this.rows.every(row =>
      row.fields.every(field =>
        field.fieldName.trim() !== '' &&
        field.value.trim() !== '' &&
        field.rule.trim() !== ''
      )
    );
  }


  addRow() {
    this.rows.push({
      fields: [
        { fieldName: '', value: '', rule: '' },
        { fieldName: '', value: '', rule: '' },
        { fieldName: '', value: '', rule: '' }
      ]
    });
  }

  removeRow(index: number) {
    this.rows.splice(index, 1);
     this.product.provisioningAndReporting.isSelfBillingEnabled= false;
  }

  reportingFileTypes = [
    { id: 1, name: 'Excel' },
    { id: 2, name: 'PDF' },
    { id: 3, name: 'CSV' }];

  customerFields = [
    { id: 1, name: 'Customer ID' },
    { id: 2, name: 'First Name' },
    { id: 3, name: 'Last Name' },
    { id: 4, name: 'Phone Number' },
    { id: 5, name: 'Province' },
    { id: 6, name: 'Status' },
    { id: 7, name: 'Plan Start Date' },
    { id: 8, name: 'Plan Termination Date' }
  ];

  reportingFileTypeDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    itemsShowLimit: 2,
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    enableCheckAll: true,
    allowSearchFilter: true,
  };

  months = [
    { id: 1, name: 'January' },
    { id: 2, name: 'February' },
    { id: 3, name: 'March' },
    { id: 4, name: 'April' },
    { id: 5, name: 'May' },
    { id: 6, name: 'June' },
    { id: 7, name: 'July' },
    { id: 8, name: 'August' },
    { id: 9, name: 'September' },
    { id: 10, name: 'October' },
    { id: 11, name: 'November' },
    { id: 12, name: 'December' }
  ];
  reportingPeriodDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'name',
    allowSearchFilter: false,
    closeDropDownOnSelection: true
  };
  selfBillingDropdownSettings = {
    singleSelection: false,
    idField: 'fieldName',
    textField: 'fieldName',
    itemsShowLimit: 1,
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    enableCheckAll: true,
    allowSearchFilter: true,
  };
  censusDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    itemsShowLimit: 1,
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    enableCheckAll: true,
    allowSearchFilter: true,
  };

  onProvisioningSelfBilling() {
    const fieldNames = this.rows.flatMap(obj =>
      obj.fields.map(field => field.fieldName)
    );

    // Convert string array to array of objects with fieldName property
    this.product.provisioningAndReporting.fieldsForSelfBilling = fieldNames.map(name => ({ fieldName: name }));

    console.log("signup form data:", this.product.provisioningAndReporting.fieldsForSelfBilling);

    this.product.provisioningAndReporting.isSelfBillingEnabled = true;
  }

  // ************************************ Conditional Tables ******************************************
  selectedZone = false;
  selectedTier = false;
  selectedAge = false;
  selectedVariant = false;
  selectedCategory = false;

  showPricingTable = false;
  showTableType: string = '';

  // Pricing matrix for all possible combinations
  pricingMatrix: {
    [zone: string]: any;
  } = {};

  // For simpler tables (zone -> item only, for example)
  flatPricingMatrix: any = {};

  showTable(): void {
    this.updateSelectedFlags();
    this.initializePricingMatrix();
    this.showPricingTable = true;
  }

  updateSelectedFlags(): void {
    this.selectedZone = this.product.areas.areasData.length > 0;
    this.selectedTier = this.product.tiers.tiersData.length > 0;
    this.selectedAge = this.product.ageBands.ageBandsData.length > 0;
    this.selectedVariant = this.product.variants.variantsData.length > 0;
    this.selectedCategory = this.product.serviceLevel.servicesData.length > 0;

    this.resolveTableFormat();
  }
  resolveTableFormat(): void {
    const z = this.selectedZone;
    const t = this.selectedTier;
    const a = this.selectedAge;
    const v = this.selectedVariant;
    const c = this.selectedCategory;

    if (z && t && a && v && c) this.showTableType = 'zone-tier-age-variant-category';
    else if (z && t && a && v) this.showTableType = 'zone-tier-age-variant';
    else if (z && t && a && c) this.showTableType = 'zone-tier-age-category';
    else if (z && t && v && c) this.showTableType = 'zone-tier-variant-category';
    else if (z && a && v && c) this.showTableType = 'zone-age-variant-category';
    else if (t && a && v && c) this.showTableType = 'tier-age-variant-category';
    else if (z && t && a) this.showTableType = 'zone-tier-age';
    else if (z && a && v) this.showTableType = 'zone-age-variant';
    else if (z && a && c) this.showTableType = 'zone-age-category';
    else if (z && t && v) this.showTableType = 'zone-tier-variant';
    else if (z && t && c) this.showTableType = 'zone-tier-category';
    else if (t && a && c) this.showTableType = 'tier-age-category';
    else if (t && v && c) this.showTableType = 'tier-variant-category';
    else if (z && v && c) this.showTableType = 'zone-variant-category';
    else if (t && c) this.showTableType = 'tier-category';
    else if (t && v) this.showTableType = 'tier-variant';
    else if (v && c) this.showTableType = 'variant-category';
    else if (z && t) this.showTableType = 'zone-tier';
    else if (z && v) this.showTableType = 'zone-variant';
    else if (z && c) this.showTableType = 'zone-category';
    else if (t && a) this.showTableType = 'tier-age';
    else if (z && a) this.showTableType = 'zone-age';
    else if (a && c) this.showTableType = 'age-category';
    else if (z) this.showTableType = 'zone-only';
    else this.showTableType = 'default';
  }

  initializePricingMatrix(): void {
    const zRows = this.product.areas.areasData.map(z => z.name || 'default');
    const tRows = this.product.tiers.tiersData.map(t => t.name || 'default');
    const aRows = this.product.ageBands.ageBandsData.map(a => `${a.start}-${a.end}` || 'default');
    const vRows = this.product.variants.variantsData.map(v => v.name || 'default');
    const cRows = this.product.serviceLevel.servicesData.map(c => c.name || 'default');

    for (const z of zRows.length ? zRows : ['default']) {
      for (const t of tRows.length ? tRows : ['default']) {
        for (const a of aRows.length ? aRows : ['default']) {
          for (const v of vRows.length ? vRows : ['default']) {
            for (const c of cRows.length ? cRows : ['default']) {
              this.initializePricingPath(z, t, a, v, c);
            }
          }
        }
      }
    }
  }

  initializePricingPath(...keys: string[]) {
    let ref = this.product.pricingMatrix;
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i] && keys[i].trim() !== '' ? keys[i] : 'default';

      if (!ref[key]) {
        ref[key] = i === keys.length - 1
          ? {
            'Unit Price': 0,
            'Advisor Commission': 0,
            'TPA Commission': 0,
            'Other Fees': 0
          }
          : {};
      } else if (i === keys.length - 1 && typeof ref[key] === 'object') {
        // If object already exists, patch missing fields (in case of partial data)
        ref[key] = {
          'Unit Price': ref[key]['Unit Price'] ?? 0,
          'Advisor Commission': ref[key]['Advisor Commission'] ?? 0,
          'TPA Commission': ref[key]['TPA Commission'] ?? ref[key]['TPA Commission'] ?? 0,
          'Other Fees': ref[key]['Other Fees'] ?? 0
        };
      }

      ref = ref[key];
    }
  }

  getPricingValue(
    zone: string,
    tier: string,
    age: string,
    variant: string,
    category: string,
    field: keyof PricingDetails
  ): number {
    try {
      return (
        this.product.pricingMatrix?.[zone || 'default']
        ?.[(tier || 'default')]
        ?.[(age || 'default')]
        ?.[(variant || 'default')]
        ?.[(category || 'default')]
        ?.[field] ?? 0
      );
    } catch {
      return 0;
    }
  }


  setPricingValue(
    zone: string,
    tier: string,
    age: string,
    variant: string,
    category: string,
    field: keyof PricingDetails,
    value: number
  ): void {
    const keys = [zone, tier, age, variant, category].map(k => k || 'default');

    let ref = this.product.pricingMatrix;
    for (const key of keys) {
      if (!ref[key]) ref[key] = {};
      ref = ref[key];
    }

    ref[field] = value;
  }


  openBookletPreview(): void {
    try {
      const base64 = this.product.productDetails.bookletFile;
      const url = `data:application/pdf;base64,${base64}`;
      this.bookletUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      this.showTileExcelPopup = true
    } catch (error) {
      console.log("booklet error :", error)
    }
  }


  // Update Product
  onUpdateProduct(): void {
    this.productUpdated.emit(this.product);
  }
  ngOnInit(): void {
    this.getLanguageTokens();
    this.product = cloneDeep(this.productData);

    // const iframe = document.getElementById('pdfViewer') as HTMLIFrameElement;
    // iframe.src = this.bookletUrl;
    // console.log("this.bookletUrl ngOninint:", this.bookletUrl)
    // this.updateFilteredProvinces()
    this.filteredProvinces = this.product.productInfo.selectedProvinces;
    // this.setBookletFileUrl(this.product.productDetails.bookletFile);

    //set previous signup data
    this.rows = [
      {
        fields: this.product.signUpData.map(item => ({
          fieldName: item.fieldName,
          value: item.value,
          rule: item.rule
        }))
      }
    ]

    const fieldNames = this.rows.flatMap(obj =>
      obj.fields.map(field => field.fieldName)
    );

    // Convert string array to array of objects with fieldName property
    this.product.provisioningAndReporting.fieldsForSelfBilling = fieldNames.map(name => ({ fieldName: name }));
    console.log("Product :", this.product);

    // showing pricing tables
    this.showTable()

  }

  //close popup
  handleCancel(): void {
    this.onClose.emit();
  }
}

export interface PricingDetails {
  'Unit Price'?: number;
  'Advisor Commission'?: number;
  'TPA Commission'?: number;
  'Other Fees'?: number;
}